import * as React from 'react';
import { FunctionComponent } from 'react';
import { Button, Spinner } from '@iba-team/portal-react-components/dist';
import { ReactComponent as UploadOutlined }  from '@iba-team/portal-react-components/dist/svg/outline/download.svg';
import { useTranslation } from 'react-i18next';

export interface ExportButtonProps {
  isDownloading: boolean,
  onClick: () => void,
}

const ExportButton: FunctionComponent<ExportButtonProps> = (props) => {
  const {t} = useTranslation();

  return (
    <Button
      icon={props.isDownloading ? <Spinner /> : <UploadOutlined />}
      disabled={props.isDownloading}
      onClick={props.onClick }
      className={'download_button'}
      theme={{ color: 'theme', variant: 'secondary' }}
    >
      <div>{t('export')}</div>
    </Button>
  );
};

export default ExportButton;